<script>
import FullCalendar from '@fullcalendar/vue'
import FullCalendarHandler from "../../../../common/mixins/FullCalendarHandler.vue";

export default {
    name: 'ClientDeadlinesFullCalendar',

    props: {
        client: null,
    },

    data() {
        return {
            deadlines: [],
            todos: [],
            bankHolidays: [],
            absences: [],
        }
    },
    components: {FullCalendar},

    mixins: [FullCalendarHandler],


    methods: {
        goTo(customData) {
            this.$store.commit('browsing/SET_YEAR', customData.year)
            this.$store.commit('reportingVM/SET_SEARCH', customData.client_name)
            window.location.href = customData.url
        },

        async getItems() {
            try {
                this.loading = true
                const response = await axios.get(
                    `/reporting/clients/${this.client}/calendar/${this.year}/${this.month}`
                )
                this.deadlines = response.data.data.deadlines.data
                this.todos = response.data.data.todos.data
                this.bankHolidays = response.data.data.bankHolidays.data
                this.calendarOptions.events = this.todos.concat(this.deadlines.concat(this.absences.concat(this.bankHolidays)))
                this.loading = false
            } catch (error) {
                console.log(error)
                this.handleErrors(error.response)
            }
        },

        handleErrors(errorResponse) {
            this.loading = false
            this.errorMessage =
                "Une erreur s'est produite, les données n'ont pu être chargées. Veuillez réactualiser la page."
            this.hasErrors = true
        },
    },
}
</script>

<template>
    <div class="w-100">
        <full-calendar ref="myFullCalendar" :options="calendarOptions"/>
    </div>
</template>

<style scoped></style>
